// Same Sleep carousel markup/styles; a finite rail avoids clone/snap startup drift.
if (!customElements.get('steadia-muscle-reviews')) {
  customElements.define('steadia-muscle-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const track = this.querySelector('[data-track]');
      const cards = [...track.children];
      if (cards.length < 2) return;
      this.querySelector('.src-arrows').hidden = false;
      let current = 0;
      const previous = this.querySelector('[data-slide="-1"]');
      const next = this.querySelector('[data-slide="1"]');
      const padding = () => parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      const destination = i => Math.max(0, cards[i].offsetLeft - padding());
      const announce = () => {
        const left = track.scrollLeft;
        let best = Infinity;
        cards.forEach((card, i) => {
          const distance = Math.abs(destination(i) - left);
          if (distance < best) { best = distance; current = i; }
        });
        previous.disabled = left <= 1;
        next.disabled = left >= track.scrollWidth - track.clientWidth - 1;
        this.querySelector('[data-status]').textContent = this.dataset.statusTemplate.replace('__CURRENT__', current + 1);
      };
      const go = i => {
        current = Math.max(0, Math.min(cards.length - 1, i));
        track.scrollTo({left: destination(current), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => go(current + Number(button.dataset.slide)), {signal}));
      track.addEventListener('scrollend', announce, {signal});
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      }, {signal});
      const align = () => { track.scrollTo({left: destination(current), behavior:'instant'}); announce(); };
      this.observer = new ResizeObserver(align);
      this.observer.observe(track);
      requestAnimationFrame(align);
      document.fonts.ready.then(() => { if (this.isConnected) align(); });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}
